import type { FC } from "react";
import { MouseEvent } from "react";

import { t } from "i18n/i18n";
import { DeleteReferenceKeys } from "i18n/i18next";
import { IconSizeType, LegacyButton } from "mds/components/LegacyButton";
import { TrashDeleteIcon } from "mds/icons";

export interface DeleteIconButtonProps {
  onClick: () => void;
  reference: DeleteReferenceKeys;
  eventPrefix?: string;
  size?: IconSizeType;
}

// TODO: We have separate DeleteButtons that are similar, review and potentially combine abstractions.
export const ToolbarDeleteIconButton: FC<DeleteIconButtonProps> = ({
  onClick,
  eventPrefix,
  reference,
  size = "s",
}) => {
  return (
    <LegacyButton
      eventName={eventPrefix ? `${eventPrefix}Delete` : undefined}
      kind="destructive"
      size={size}
      title={t("edit_delete_widget.delete", { context: reference })}
      iconOnly
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <TrashDeleteIcon />
    </LegacyButton>
  );
};
